/* eslint-disable linebreak-style */
/**
 * Upload a file (PDF resume) to Cloudinary using an unsigned upload preset.
 * Returns the secure public URL on success.
 */

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export async function uploadResume(file) {
  if (!CLOUD_NAME || !UPLOAD_PRESET) {
    throw new Error('Cloudinary is not configured. Check .env.local.');
  }
  if (!file) throw new Error('No file selected.');

  const data = new FormData();
  data.append('file', file);
  data.append('upload_preset', UPLOAD_PRESET);
  data.append('folder', 'web7labs/resumes');

  // PDFs go through the "raw" resource endpoint on Cloudinary.
  const url = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/raw/upload`;

  const res = await fetch(url, { method: 'POST', body: data });
  if (!res.ok) {
    const errText = await res.text().catch(() => '');
    throw new Error(`Resume upload failed (${res.status}). ${errText}`);
  }
  const json = await res.json();
  return json.secure_url;
}
